import { ICompanyPickerTag } from '../../companyGroups/detail/CompanyGroupCompanyPicker';

const VALID_LIFECYCLE_STATUSES = ['Operating', 'Accounting Ledger Only', 'TBD'];

export const validateCompany = (value: ICompanyPickerTag[]): true | string => {
  if (!value || value.length === 0 || !value[0].companyCode) {
    return 'Please select a company code.';
  }
  return VALID_LIFECYCLE_STATUSES.includes(value[0].lifecycleStatus ?? '')
    ? true
    : 'Company code must have a Lifecycle Status of Operating, Accounting Ledger Only, or TBD.';
};

export const getCompanyErrorMessage = (
  value: ICompanyPickerTag[],
  formErrorMessage?: string,
): string | undefined => {
  if (!formErrorMessage) {
    return undefined;
  }
  const result = validateCompany(value);
  return result === true ? undefined : result;
};
